import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/index.scss';
import '../../scss/explain.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moFreshCity from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';

interface IProps {}
interface IState {}

const ExplainPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry, freshYear } = moIndex;
  const { overview } = moFreshCity;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <PDF>
      <section className="fresh-salary_101">
        <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
        <section className="content-101101">
          <section className="title-101101">
            <Title title="应届生起薪 - 按城市" bigTitle="人力指标" tag={`${freshYear}届`} />
          </section>

          <section className="box-15050">
            <strong>解读：</strong>
            <section className="box-151">
              {overview?.map((text: any, index: number) => (
                <p key={index}>
                  <span className="ico-11"><b /></span>
                  <i>{text}</i>
                </p>
              ))}
            </section>
          </section>
        </section>
        <FootPdf />
      </section>
    </PDF>
  );
};

export default observer(ExplainPDF);
